import React, { useState } from 'react';

import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const AnalyticsHeader = ({ onFilterChange, onExport, filters }) => {
  const [exportLoading, setExportLoading] = useState(false);

  const timeRangeOptions = [
    { value: 'last7days', label: 'Last 7 Days' },
    { value: 'last30days', label: 'Last 30 Days' },
    { value: 'last3months', label: 'Last 3 Months' },
    { value: 'last6months', label: 'Last 6 Months' },
    { value: 'lastyear', label: 'Last Year' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const brandOptions = [
    { value: 'all', label: 'All Brands' },
    { value: 'coca-cola', label: 'Coca-Cola' },
    { value: 'pepsi', label: 'Pepsi' },
    { value: 'samsung', label: 'Samsung' },
    { value: 'lg', label: 'LG' },
    { value: 'nestle', label: 'Nestlé' }
  ];

  const storeOptions = [
    { value: 'all', label: 'All Stores' },
    { value: 'dhaka-gulshan', label: 'Dhaka - Gulshan' },
    { value: 'dhaka-dhanmondi', label: 'Dhaka - Dhanmondi' },
    { value: 'chittagong-agrabad', label: 'Chittagong - Agrabad' },
    { value: 'sylhet-zindabazar', label: 'Sylhet - Zindabazar' },
    { value: 'rajshahi-shaheb-bazar', label: 'Rajshahi - Shaheb Bazar' }
  ];

  const brandingTypeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'window-display', label: 'Window Display' },
    { value: 'billboard', label: 'Billboard' },
    { value: 'led-screen', label: 'LED Screen' },
    { value: 'in-store-static', label: 'In-Store Static' },
    { value: 'gondola-branding', label: 'Gondola Branding' },
    { value: 'shelf-talker', label: 'Shelf Talker' },
    { value: 'fsu', label: 'FSU' },
    { value: 'brand-zone', label: 'Brand Zone' },
    { value: 'exhibition-zone', label: 'Exhibition Zone' }
  ];

  const handleExport = async (format) => {
    setExportLoading(true);
    try {
      await onExport(format);
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <div className="bg-surface border border-border rounded-lg p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
        <div>
          <h1 className="text-2xl font-semibold text-foreground mb-2">Brand Analytics</h1>
          <p className="text-muted-foreground">
            Comprehensive reporting and analysis for branding costs and installation performance
          </p>
        </div>
        
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            iconName="Download"
            iconPosition="left"
            loading={exportLoading}
            onClick={() => handleExport('pdf')}
            className="hidden sm:flex"
          >
            Export PDF
          </Button>
          <Button
            variant="outline"
            iconName="FileSpreadsheet"
            iconPosition="left"
            loading={exportLoading}
            onClick={() => handleExport('excel')}
            className="hidden sm:flex"
          >
            Export Excel
          </Button>
          <Button
            variant="ghost"
            iconName="MoreVertical"
            className="sm:hidden"
          />
        </div>
      </div>
      {/* Filters */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          label="Time Range"
          options={timeRangeOptions}
          value={filters?.timeRange}
          onChange={(value) => onFilterChange('timeRange', value)}
          className="w-full"
        />
        
        <Select
          label="Brand"
          options={brandOptions}
          value={filters?.brand}
          onChange={(value) => onFilterChange('brand', value)}
          searchable
          className="w-full"
        />
        
        <Select
          label="Store Location"
          options={storeOptions}
          value={filters?.store}
          onChange={(value) => onFilterChange('store', value)}
          searchable
          className="w-full"
        />
        
        <Select
          label="Branding Type"
          options={brandingTypeOptions}
          value={filters?.brandingType}
          onChange={(value) => onFilterChange('brandingType', value)}
          className="w-full"
        />
      </div>
    </div>
  );
};

export default AnalyticsHeader;